import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "form-empty"
}
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "title" }

import { computed, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import { formatMetadata } from "@/common/utils/common";
import { toast } from "@/common/utils/toast";

import { formQuestionList } from "@/common/api/rest/form/question";
import { methodQuestionList } from "@/common/api/rest/method/method-question";
import { analysisFormList } from "@/common/api/rest/analysis/form";
import { analysisMethodList } from "@/common/api/rest/analysis/method";
import {
  analysisAnswerShow,
  analysisAnswerPatch,
} from "@/common/api/rest/analysis/answer";

import type { AnalysisType } from "@/common/types/analysis";
import type { FormType } from "@/common/types/form";
import type { AnswersType, QuestionType } from "@/common/types/question";

import { viewQuestions } from "@/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'questions',
  props: {
    data: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const route = useRoute();

const emit = __emit;

const props = __props;

const answers = ref<AnswersType | null>(null);
const formData = ref<FormType[]>([]);
const methodData = ref<any[]>([]);
const questionData = ref<{ [key: string]: QuestionType[] }>({});

const accountId = computed(() => route.params.id as string);

async function fetchForms() {
  if (!props.data) return;

  await analysisFormList(props.data.account_id, {
    analysis_id: props.data.analysis_id,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        formData.value = data.list;
        data.list.forEach(async (item: FormType) => {
          await formQuestionList(accountId.value, item.form_id, { full: true })
            .then((response) => {
              const { success, data, message } = response;

              if (success) {
                questionData.value[item.form_id] = data.list;
              } else {
                toast({ message: message, type: "error" });
              }
            })
            .catch(() => {
              toast({ message: t("error.default"), type: "error" });
            });
        });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function fetchMethods() {
  if (!props.data) return;

  await analysisMethodList(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    analysis_id: props.data.analysis_id,
    full: true,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        methodData.value = data.list;
        data.list.forEach(async (item: any) => {
          await methodQuestionList(item.account_id, item.group_id, {
            full: true,
          })
            .then((response) => {
              console.log("response", response);
              const { success, data, message } = response;

              if (success) {
                questionData.value[item.form_id] = data.list;
              } else {
                toast({ message: message, type: "error" });
              }
            })
            .catch(() => {
              toast({ message: t("error.default"), type: "error" });
            });

          if (item.metadata) {
            item.metadata?.forEach((field: any) => {
              if (field.type === "RANGE") {
                if (!questionData.value[item.category_id]) {
                  questionData.value[item.category_id] = [];
                }

                questionData.value[item.category_id].push({
                  ...field,
                  question_id: field.field_id,
                  type: "INPUT",
                });
              }
            });
          }
        });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function fetchAnswers() {
  if (!props.data) return;

  await analysisAnswerShow(props.data.account_id, props.data.answer_id)
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        answers.value = data;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

async function patchAnswers(payload: any) {
  console.log("payload", payload);
  await analysisAnswerPatch(props.data.account_id, props.data.answer_id, {
    metadata: JSON.stringify(payload),
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        toast({ message: message, type: "success" });
        fetchAnswers();
        fetchForms();
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

onMounted(async () => {
  await fetchAnswers();
  await fetchForms();
  await fetchMethods();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["analyse-tab", { width: __props.width }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (formData.value.length === 0 && methodData.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("analysis.texts.empty_questions")), 1))
        : _createCommentVNode("", true),
      (formData.value.length > 0 && __props.data.answer_id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)("analysis.labels.form_questions")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(viewQuestions), {
                key: index,
                field: "form",
                "account-id": accountId.value,
                code: item.code,
                name: item.name,
                "answers-id": __props.data.answer_id,
                answers: answers.value,
                "owner-id": item.form_id,
                orders: _unref(formatMetadata)(item.metadata)?.['orders'] ?? [],
                questions: questionData.value[item.form_id] ?? [],
                "onUpdate:data": _cache[0] || (_cache[0] = ($event: any) => (patchAnswers($event)))
              }, null, 8, ["account-id", "code", "name", "answers-id", "answers", "owner-id", "orders", "questions"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true),
      (methodData.value.length > 0 && __props.data.answer_id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(t)("analysis.labels.method_questions")), 1),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(methodData.value, (item, index) => {
              return (_openBlock(), _createBlock(_unref(viewQuestions), {
                key: index,
                field: "method",
                code: item.code,
                name: item.name,
                "account-id": __props.data.account_id,
                "answers-id": __props.data.answer_id,
                answers: answers.value,
                "owner-id": item.method_id,
                orders: [],
                questions: questionData.value[item.category_id] ?? [],
                "onUpdate:data": _cache[1] || (_cache[1] = ($event: any) => (patchAnswers($event)))
              }, null, 8, ["code", "name", "account-id", "answers-id", "answers", "owner-id", "questions"]))
            }), 128))
          ], 64))
        : _createCommentVNode("", true)
    ])
  ], 2))
}
}

})